import './modal.css'
import nextButton from '../../sidebar/images/next (1).png'
import {useState} from "react";

const Modal = ({isOpen, toggle, item, prev, next}) => {
    const [isActive, setIsActive] = useState(false);

    const handleClick = event => {
        // 👇️ toggle isActive state on click
        setIsActive(current => !current);
    };
    return (
        <div>
            {
                isOpen &&
                <div className={'modal_father'}>
                    <div className="menu_modal">
                        <div onClick={prev} className="prev_button"><img src={nextButton} alt="prev"/></div>
                        <div className="modal_left_side">
                            <img src={item.image} className={item.type === 'contain'  ? 'contain' : 'cover'} alt="img"/>
                            <div className={isActive ? 'open_info_class' : 'modal_right_side'}>
                                <div className="modal_right_side_title">{item.name}</div>
                                <p className="modal_right_side_desc">{item.desc}</p>
                                <div className="modal_right_side_price">{item.price}</div>
                            </div>
                        </div>
                        <div onClick={next} className="next_button"><img src={nextButton} alt="next"/></div>
                        <button className="close_button" onClick={toggle}>X</button>
                        <div onClick={handleClick} className="open_info">Info</div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Modal
